import api from "@/utils/api";
export const fetchLeadColumns = async () => {
  const response = await api.req<{ columns: any[] }>({
    url: "/columns/?limit=100&active=true&include_options=true",
    method: api.Method.GET,
  });

  if (response.data?.columns) {
    return {
      success: true,
      columns: response.data.columns, // Already filtered by active=true on server side
    };
  }

  return { success: false, columns: [] };
};

export const getLeadDetails = async (uuid: string) => {
  const response = await api.req({
    url: `/leads/${uuid}`,
    method: api.Method.GET,
  });
  return response;
};

export const createLead = async (leadData: any) => {
  const response = await api.req({
    url: "/leads/create_lead",
    method: api.Method.POST,
    body: leadData,
  });
  return response;
};

export const updateLead = async (uuid: string, formData: any, userRemark: string, ownerUuid?: string) => {
  const updateData = {
    formData: formData,
    uuid: uuid,
    userRemark: userRemark,
    // Omitted unless the caller means to change the owner: the API treats any value
    // it receives as a reassignment request.
    ...(ownerUuid !== undefined && { ownerUuid }),
  };

  const response = await api.req({
    url: `/leads/update_lead`,
    method: api.Method.POST,
    body: updateData,
  });
  return response;
};

export const updateLeadStatus = async (uuid: string, statusUuid: string, userRemark: string) => {
  const updateData = {
    leadUuid: uuid,
    status_to: statusUuid,
    userRemark: userRemark
  };

  const response = await api.req({
    url: `/leads/update_status`,
    method: api.Method.POST,
    body: updateData,
  });

  return response;
};

export const getLeadRemarks = async (uuid: string) => {
  const response = await api.req({
    url: `/leads/remarks/${uuid}`,
    method: api.Method.GET,
  });
  return response;
};

export const addComment = async (params: any) => {
  const response = await api.req({
    url: `/leads/remarks`,
    method: api.Method.POST,
    body: params,
  });
  return response;
};

export const updateLeadColumns = async (params: any) => {
  const response = await api.req({
    url: `/user-leads-settings/columns/save`,
    method: api.Method.POST,
    body: params,
  });
  return response;
}

// export const sendPostReq = async (params: any, endpoint: any) => {
//   const response = await api.req({
//     url: endpoint,
//     method: api.Method.POST,
//     body: params,
//   });
//   return response;
// }


